import styled from 'foundations-theming/utils';
const StickyFooter = styled.div.withConfig({
  displayName: "StickyFooter"
})(({
  theme,
  mobile
}) => ({
  position: 'sticky',
  bottom: 0,
  marginLeft: mobile ? '-8px' : 'auto',
  marginRight: mobile ? '-8px' : 'auto',
  backgroundColor: mobile ? theme.color['fill-surface-recessed'] : theme.color['fill-surface-default']
}));
export default StickyFooter;